import styled from 'styled-components';

export const ShippingStatusContainerStyled = styled.div`
  width: 100%;
  max-width: 640px;
  max-height: 85vh;
  overflow: auto;
  padding: 1.5rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 8px;
  .modal_title {
    font-size: 18px;
    margin-bottom: 14px;
  }
`;
